


import { Draggable } from "@hello-pangea/dnd";
const IMAGE_BASE_URL = "https://uptask.visiontrek.io";
 
 
const STATUS_LABELS = {
  TODO: "To Do",
  IN_PROGRESS: "In Progress",
  HOLD: "Hold",
  REVIEW: "Review",
  DONE: "Done",
};
 
 
export default function TaskCard({
  task,
  index,
  onClick,
  draggable = true,
  compact = false,   // 👈 ADD THIS
}) {
 
 
 
 
// ✅ Normalize creator
const creatorName =
  typeof task.creator === "object"
    ? task.creator?.name
    : task.creator;
 
const creatorProfilePic =
  typeof task.creator === "object"
    ? task.creator?.profile_pic
    : task.creator_profile_pic;

// ✅ DEADLINE STATUS
const todayDate = new Date().toISOString().split("T")[0];
const dueDate = task.due_date?.split(" ")[0];

let deadlineStatus = null;
if (dueDate && task.status !== "DONE" && task.status !== "HOLD") {
  if (dueDate < todayDate) {
    deadlineStatus = "OVERDUE";
  } else if (dueDate === todayDate) {
    deadlineStatus = "TODAY";
  }
}
 
const CardContent = compact ? (
 
  /* ===========================
     ✅ COMPACT MODE (My Tasks)
     =========================== */
  <div
    onClick={onClick}
    className="
      bg-blue-50
      border
      border-blue-200
      text-blue-900
      rounded-xl
      p-3
      shadow-sm
      hover:shadow-md
      transition-all
      cursor-pointer
    "
  >
 
   
    <h3 className="text-sm font-medium truncate">
      {task.title}
    </h3>
  </div>
 
) : (
 
  /* ===========================
     ✅ FULL GLASS MODE (All View)
     =========================== */
<div
  onClick={onClick}
className="
 
relative
overflow-hidden
rounded-[20px]
p-5
backdrop-blur-2xl
bg-white/5
border border-white/20
shadow-[0_10px_40px_rgba(0,0,0,0.35)]
hover:bg-white/10
transition-all duration-300
 
"
>
 
{/* ✨ Masked Glass Reflection */}
<div className="absolute -top-16 -right-16 w-40 h-40 bg-white/50 rounded-full blur-2xl opacity-50 pointer-events-none"></div>
 
{/* ✨ Glass Shine Edge */}
 
<div className="flex items-center justify-start mt-[-8px] ">
</div>
    {/* ===== TITLE + PRIORITY ===== */}
    <div className="flex justify-between items-start">
      <h3 className="text-white font-semibold text-sm">
        {task.title}
      </h3>
     
 
      <div className="flex gap-2 items-center">
        {deadlineStatus && (
          <div className="relative group">
            <span
              className={`text-[10px] px-2 py-1 rounded-full font-bold
                ${deadlineStatus === "OVERDUE" ? "bg-red-600 text-white" : "bg-orange-500 text-white"}
              `}
            >
              {deadlineStatus}
            </span>
            
            {/* TOOLTIP */}
            <div className="
              absolute top-full left-1/2 -translate-x-1/2 mb-2
              hidden group-hover:block
              bg-black text-white text-[10px]
              px-2 py-1 rounded-md
              whitespace-nowrap
              shadow-lg z-50
            ">
              {deadlineStatus === "OVERDUE" ? "Task is past due date!" : "Task is due today!"}
            </div>
          </div>
        )}

        <span
          className={`text-[10px] px-2 py-1 rounded-full font-medium
            ${
              task.priority === "HIGH"
                ? "bg-red-500/20 text-red-400"
                : task.priority === "MEDIUM"
                ? "bg-yellow-500/20 text-yellow-400"
                : "bg-green-500/20 text-green-400"
            }
          `}
        >
          {task.priority}
        </span>
      </div>
    </div>
 
 
    {/* ===== ASSIGNEES (TOP) ===== */}
<div className="flex items-center gap-2 mt-3">
 
{task.assignees?.length > 0 ? (
  <>
    {/* Avatars */}
    <div className="flex -space-x-2">
      {task.assignees.map((user) => (
        <img
          key={user.id}
          // src={${IMAGE_BASE_URL}${user.profile_pic}}
          src={`${IMAGE_BASE_URL}${user.profile_pic}`}
          className="w-7 h-7 rounded-full border-2 border-white object-cover"
          alt={user.name}
        />
      ))}
    </div>
 
    {/* Names */}
    <span className="text-xs text-gray-200">
      {task.assignees.map((u) => u.name).join(", ")}
    </span>
  </>
) : (
  <span className="text-xs text-gray-400">Unassigned</span>
)}
 
</div>
 
    <p className="text-gray-400 text-[12px] mt-2 line-clamp-2">
                    {task.description}
                  </p>
 
    {/* ===== DATES ===== */}
    <div className="flex justify-between text-[10px] text-gray-300 mt-3">
      <div>
 
 
 
         
        <p>Created</p>
        <p>
          {task.created_at
            ? task.created_at.split(" ")[0]
            : "-"}
        </p>
      </div>
 
      <div>
        <p>Due</p>
        <p>
          {task.due_date
            ? task.due_date.split(" ")[0]
            : "-"}
        </p>
      </div>
    </div>
 
    {/* ===== PROGRESS ===== */}
    <div className="mt-3">
      <div className="h-1 bg-white/20 rounded-full">
        <div
          className="h-1 bg-gradient-to-r from-cyan-400 to-blue-500 rounded-full"
          // style={{
          //   width: ${task.completion_percent || 0}%,
          // }}

          style={{
            width: `${task.completion_percent || 0}%`,
          }}
        />
      </div>
      <p className="text-[10px] text-gray-300 mt-1 text-right">
        {task.completion_percent || 0}%
      </p>
    </div>
 
      {/* ===== ASSIGNEES + STATUS ===== */}
      <div className="mb-[-18px]">
      <span className="text-[10px] text-gray-400 mb-1">
    Creator
  </span>
  </div>
      <div className="flex justify-between items-center mt-4">
 
 
 
{/* ===== CREATOR (BOTTOM) ===== */}
<div className="flex items-center gap-2 mt-2">
 
  {creatorProfilePic ? (
    <img
      // src={${IMAGE_BASE_URL}${creatorProfilePic}}
      src={`${IMAGE_BASE_URL}${creatorProfilePic}`}
      className="w-6 h-6 rounded-full object-cover border border-white/20"
      alt={creatorName}
    />
  ) : (
    <div className="w-6 h-6 rounded-full bg-blue-600 flex items-center justify-center text-white text-xs">
      {creatorName?.charAt(0)}
    </div>
  )}
 
  <span className="text-[11px] text-gray-400">
    {creatorName}
  </span>
 
</div>
 
<div className="flex items-center gap-2">
  {/* Status Badge */}
  <span
    className={`text-[10px] px-3 py-1 rounded-full font-medium
      ${
        task.status === "DONE"
          ? "bg-green-500/20 text-green-400"
          : task.status === "IN_PROGRESS"
          ? "bg-cyan-500/20 text-cyan-400"
          : task.status === "REVIEW"
          ? "bg-purple-500/20 text-purple-400"
          : task.status === "HOLD"
          ? "bg-red-500/20 text-red-400"
          : task.status === "BLOCKED"
          ? "bg-red-500/20 text-red-400"
          : "bg-blue-500/20 text-blue-400"
      }
    `}
  >
    {/* {task.status} */}
    {STATUS_LABELS[task.status] || task.status}
  </span>
 
  {/* 🔒 Locked Badge */}
  {task.is_locked && (
    <span className="text-[10px] px-2 py-1 rounded-full bg-orange-500/20 text-orange-400">
      🔒 Locked
    </span>
  )}
</div>
 
     
    </div>
 
   
  </div>
);
 
 
  // if (!draggable) return CardContent;
  if (!draggable || task.is_locked) return CardContent;
 
 
  return (
    <Draggable draggableId={String(task.id)} index={index}>
      {(provided) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          style={provided.draggableProps.style}
        >
          {CardContent}
        </div>
      )}
    </Draggable>
  );
}




// import { Draggable } from "@hello-pangea/dnd";
// const IMAGE_BASE_URL = "https://uptask.visiontrek.io";
 
 
// const STATUS_LABELS = {
//   TODO: "To Do",
//   IN_PROGRESS: "In Progress",
//   HOLD: "Hold",
//   REVIEW: "Review",
//   DONE: "Done",
// };
 
 
// export default function TaskCard({
//   task,
//   index,
//   onClick,
//   draggable = true,
//   compact = false,   // 👈 ADD THIS
// }) {
 
 
 
 
// // ✅ Normalize creator
// const creatorName =
//   typeof task.creator === "object"
//     ? task.creator?.name
//     : task.creator;
 
// const creatorProfilePic =
//   typeof task.creator === "object"
//     ? task.creator?.profile_pic
//     : task.creator_profile_pic;
 
// const CardContent = compact ? (
 
//   /* ===========================
//      ✅ COMPACT MODE (My Tasks)
//      =========================== */
//   <div
//     onClick={onClick}
//     className="
//       bg-blue-50
//       border
//       border-blue-200
//       text-blue-900
//       rounded-xl
//       p-3
//       shadow-sm
//       hover:shadow-md
//       transition-all
//       cursor-pointer
//     "
//   >
 
   
//     <h3 className="text-sm font-medium truncate">
//       {task.title}
//     </h3>
//   </div>
 
// ) : (
 
//   /* ===========================
//      ✅ FULL GLASS MODE (All View)
//      =========================== */
// <div
//   onClick={onClick}
// className="
 
// relative
// overflow-hidden
// rounded-[20px]
// p-5
// backdrop-blur-2xl
// bg-white/5
// border border-white/20
// shadow-[0_10px_40px_rgba(0,0,0,0.35)]
// hover:bg-white/10
// transition-all duration-300
 
// "
// >
 
// {/* ✨ Masked Glass Reflection */}
// <div className="absolute -top-16 -right-16 w-40 h-40 bg-white/50 rounded-full blur-2xl opacity-50 pointer-events-none"></div>
 
// {/* ✨ Glass Shine Edge */}
 
// <div className="flex items-center justify-start mt-[-8px] ">
// </div>
//     {/* ===== TITLE + PRIORITY ===== */}
//     <div className="flex justify-between items-start">
//       <h3 className="text-white font-semibold text-sm">
//         {task.title}
//       </h3>
     
 
//       <span
//         className={`text-[10px] px-2 py-1 rounded-full font-medium
//           ${
//             task.priority === "HIGH"
//               ? "bg-red-500/20 text-red-400"
//               : task.priority === "MEDIUM"
//               ? "bg-yellow-500/20 text-yellow-400"
//               : "bg-green-500/20 text-green-400"
//           }
//         `}
//       >
//         {task.priority}
//       </span>
//     </div>
 
 
//     {/* ===== ASSIGNEES (TOP) ===== */}
// <div className="flex items-center gap-2 mt-3">
 
// {task.assignees?.length > 0 ? (
//   <>
//     {/* Avatars */}
//     <div className="flex -space-x-2">
//       {task.assignees.map((user) => (
//         <img
//           key={user.id}
//           src={`${IMAGE_BASE_URL}${user.profile_pic}`}
//           className="w-7 h-7 rounded-full border-2 border-white object-cover"
//           alt={user.name}
//         />
//       ))}
//     </div>
 
//     {/* Names */}
//     <span className="text-xs text-gray-200">
//       {task.assignees.map((u) => u.name).join(", ")}
//     </span>
//   </>
// ) : (
//   <span className="text-xs text-gray-400">Unassigned</span>
// )}
 
// </div>
 
//     <p className="text-gray-400 text-[12px] mt-2 line-clamp-2">
//                     {task.description}
//                   </p>
 
//     {/* ===== DATES ===== */}
//     <div className="flex justify-between text-[10px] text-gray-300 mt-3">
//       <div>
 
 
 
         
//         <p>Created</p>
//         <p>
//           {task.created_at
//             ? task.created_at.split(" ")[0]
//             : "-"}
//         </p>
//       </div>
 
//       <div>
//         <p>Due</p>
//         <p>
//           {task.due_date
//             ? task.due_date.split(" ")[0]
//             : "-"}
//         </p>
//       </div>
//     </div>
 
//     {/* ===== PROGRESS ===== */}
//     <div className="mt-3">
//       <div className="h-1 bg-white/20 rounded-full">
//         <div
//           className="h-1 bg-gradient-to-r from-cyan-400 to-blue-500 rounded-full"
//           style={{
//             width: `${task.completion_percent || 0}%`,
//           }}
//         />
//       </div>
//       <p className="text-[10px] text-gray-300 mt-1 text-right">
//         {task.completion_percent || 0}%
//       </p>
//     </div>
 
//       {/* ===== ASSIGNEES + STATUS ===== */}
//       <div className="mb-[-18px]">
//       <span className="text-[10px] text-gray-400 mb-1">
//     Creator
//   </span>
//   </div>
//       <div className="flex justify-between items-center mt-4">
 
 
 
// {/* ===== CREATOR (BOTTOM) ===== */}
// <div className="flex items-center gap-2 mt-2">
 
//   {creatorProfilePic ? (
//     <img
//       src={`${IMAGE_BASE_URL}${creatorProfilePic}`}
//       className="w-6 h-6 rounded-full object-cover border border-white/20"
//       alt={creatorName}
//     />
//   ) : (
//     <div className="w-6 h-6 rounded-full bg-blue-600 flex items-center justify-center text-white text-xs">
//       {creatorName?.charAt(0)}
//     </div>
//   )}
 
//   <span className="text-[11px] text-gray-400">
//     {creatorName}
//   </span>
 
// </div>
 
// <div className="flex items-center gap-2">
//   {/* Status Badge */}
//   <span
//     className={`text-[10px] px-3 py-1 rounded-full font-medium
//       ${
//         task.status === "DONE"
//           ? "bg-green-500/20 text-green-400"
//           : task.status === "IN_PROGRESS"
//           ? "bg-cyan-500/20 text-cyan-400"
//           : task.status === "REVIEW"
//           ? "bg-purple-500/20 text-purple-400"
//           : task.status === "BLOCKED"
//           ? "bg-red-500/20 text-red-400"
//           : "bg-blue-500/20 text-blue-400"
//       }
//     `}
//   >
//     {/* {task.status} */}
//     {STATUS_LABELS[task.status] || task.status}
//   </span>
 
//   {/* 🔒 Locked Badge */}
//   {task.is_locked && (
//     <span className="text-[10px] px-2 py-1 rounded-full bg-orange-500/20 text-orange-400">
//       🔒 Locked
//     </span>
//   )}
// </div>
 
     
//     </div>
 
   
//   </div>
// );
 
 
//   // if (!draggable) return CardContent;
//   if (!draggable || task.is_locked) return CardContent;
 
 
//   return (
//     <Draggable draggableId={String(task.id)} index={index}>
//       {(provided) => (
//         <div
//           ref={provided.innerRef}
//           {...provided.draggableProps}
//           {...provided.dragHandleProps}
//           style={provided.draggableProps.style}
//         >
//           {CardContent}
//         </div>
//       )}
//     </Draggable>
//   );
// }
 
 








// import { Draggable } from "@hello-pangea/dnd";
// const IMAGE_BASE_URL = "https://uptask.visiontrek.io";


// const STATUS_LABELS = {
//   TODO: "To Do",
//   IN_PROGRESS: "In Progress",
//   BLOCKED: "Hold",
//   REVIEW: "Review",
//   DONE: "Done",
// };


// export default function TaskCard({
//   task,
//   index,
//   onClick,
//   draggable = true,
//   compact = false,   // 👈 ADD THIS
// }) {


  

// // ✅ Normalize creator
// const creatorName =
//   typeof task.creator === "object"
//     ? task.creator?.name
//     : task.creator;

// const creatorProfilePic =
//   typeof task.creator === "object"
//     ? task.creator?.profile_pic
//     : task.creator_profile_pic;

// const CardContent = compact ? (

//   /* ===========================
//      ✅ COMPACT MODE (My Tasks)
//      =========================== */
//   <div
//     onClick={onClick}
//     className="
//       bg-blue-50
//       border
//       border-blue-200
//       text-blue-900
//       rounded-xl
//       p-3
//       shadow-sm
//       hover:shadow-md
//       transition-all
//       cursor-pointer
//     "
//   >

    
//     <h3 className="text-sm font-medium truncate">
//       {task.title}
//     </h3>
//   </div>

// ) : (

//   /* ===========================
//      ✅ FULL GLASS MODE (All View)
//      =========================== */
// <div
//   onClick={onClick}
// className="

// relative
// overflow-hidden
// rounded-[20px]
// p-5
// backdrop-blur-2xl
// bg-white/5
// border border-white/20
// shadow-[0_10px_40px_rgba(0,0,0,0.35)]
// hover:bg-white/10
// transition-all duration-300
  
// "
// >

// {/* ✨ Masked Glass Reflection */}
// <div className="absolute -top-16 -right-16 w-40 h-40 bg-white/50 rounded-full blur-2xl opacity-50 pointer-events-none"></div>

// {/* ✨ Glass Shine Edge */}

// <div className="flex items-center justify-start mt-[-8px] ">
// </div>
//     {/* ===== TITLE + PRIORITY ===== */}
//     <div className="flex justify-between items-start">
//       <h3 className="text-white font-semibold text-sm">
//         {task.title}
//       </h3>
      

//       <span
//         className={`text-[10px] px-2 py-1 rounded-full font-medium
//           ${
//             task.priority === "HIGH"
//               ? "bg-red-500/20 text-red-400"
//               : task.priority === "MEDIUM"
//               ? "bg-yellow-500/20 text-yellow-400"
//               : "bg-green-500/20 text-green-400"
//           }
//         `}
//       >
//         {task.priority}
//       </span>
//     </div>

//     {/* ===== CREATOR ===== */}
//     {/* <div className="flex items-center gap-2 mt-3">
// {creatorProfilePic ? (
//     <img
//       src={`${IMAGE_BASE_URL}${creatorProfilePic}`}
//       className="w-7 h-7 rounded-full object-cover border border-white/20"
//       alt={creatorName}
//     />
//   ) : (
//     <div className="w-7 h-7 rounded-full bg-blue-600 flex items-center justify-center text-white text-xs">
//       {creatorName?.charAt(0)}
//     </div>
//   )}

//   <span className="text-xs text-gray-200">
//     {creatorName}
//   </span>

  
//     </div> */}

//     {/* ===== ASSIGNEES (TOP) ===== */}
// <div className="flex items-center gap-2 mt-3">

// {task.assignees?.length > 0 ? (
//   <>
//     {/* Avatars */}
//     <div className="flex -space-x-2">
//       {task.assignees.map((user) => (
//         <img
//           key={user.id}
//           src={`${IMAGE_BASE_URL}${user.profile_pic}`}
//           className="w-7 h-7 rounded-full border-2 border-white object-cover"
//           alt={user.name}
//         />
//       ))}
//     </div>

//     {/* Names */}
//     <span className="text-xs text-gray-200">
//       {task.assignees.map((u) => u.name).join(", ")}
//     </span>
//   </>
// ) : (
//   <span className="text-xs text-gray-400">Unassigned</span>
// )}

// </div>

//     <p className="text-gray-400 text-[12px] mt-2 line-clamp-2">
//                     {task.description}
//                   </p>

//     {/* ===== DATES ===== */}
//     <div className="flex justify-between text-[10px] text-gray-300 mt-3">
//       <div>



         
//         <p>Created</p>
//         <p>
//           {task.created_at
//             ? task.created_at.split(" ")[0]
//             : "-"}
//         </p>
//       </div>

//       <div>
//         <p>Due</p>
//         <p>
//           {task.due_date
//             ? task.due_date.split(" ")[0]
//             : "-"}
//         </p>
//       </div>
//     </div>

//     {/* ===== PROGRESS ===== */}
//     <div className="mt-3">
//       <div className="h-1 bg-white/20 rounded-full">
//         <div
//           className="h-1 bg-gradient-to-r from-cyan-400 to-blue-500 rounded-full"
//           style={{
//             width: `${task.completion_percent || 0}%`,
//           }}
//         />
//       </div>
//       <p className="text-[10px] text-gray-300 mt-1 text-right">
//         {task.completion_percent || 0}%
//       </p>
//     </div>

//       {/* ===== ASSIGNEES + STATUS ===== */}
//       <div className="mb-[-18px]">
//       <span className="text-[10px] text-gray-400 mb-1">
//     Creator
//   </span>
//   </div>
//       <div className="flex justify-between items-center mt-4">


      
//         {/* Assignees */}
//        {/* ===== ASSIGNEES + STATUS ===== */}
// {/* ===== ASSIGNEES + STATUS ===== */}
// {/* ===== CREATOR (BOTTOM) ===== */}
// <div className="flex items-center gap-2 mt-2">

//   {creatorProfilePic ? (
//     <img
//       src={`${IMAGE_BASE_URL}${creatorProfilePic}`}
//       className="w-6 h-6 rounded-full object-cover border border-white/20"
//       alt={creatorName}
//     />
//   ) : (
//     <div className="w-6 h-6 rounded-full bg-blue-600 flex items-center justify-center text-white text-xs">
//       {creatorName?.charAt(0)}
//     </div>
//   )}

//   <span className="text-[11px] text-gray-400">
//     {creatorName}
//   </span>

// </div>

// {/* <span
//         className={`text-[10px] px-3 py-1 rounded-full font-medium
//           ${
//             task.status === "DONE"
//               ? "bg-green-500/20 text-green-400"
//               : task.status === "IN_PROGRESS"
//               ? "bg-cyan-500/20 text-cyan-400"
//               : task.status === "REVIEW"
//               ? "bg-purple-500/20 text-purple-400"
//               : task.status === "BLOCKED"
//               ? "bg-red-500/20 text-red-400"
//               : "bg-blue-500/20 text-blue-400"
//           }
//         `}
//       >
//         {task.status}
//       </span> */}


// <div className="flex items-center gap-2">
//   {/* Status Badge */}
//   <span
//     className={`text-[10px] px-3 py-1 rounded-full font-medium
//       ${
//         task.status === "DONE"
//           ? "bg-green-500/20 text-green-400"
//           : task.status === "IN_PROGRESS"
//           ? "bg-cyan-500/20 text-cyan-400"
//           : task.status === "REVIEW"
//           ? "bg-purple-500/20 text-purple-400"
//           : task.status === "BLOCKED"
//           ? "bg-red-500/20 text-red-400"
//           : "bg-blue-500/20 text-blue-400"
//       }
//     `}
//   >
//     {/* {task.status} */}
//     {STATUS_LABELS[task.status] || task.status}
//   </span>

//   {/* 🔒 Locked Badge */}
//   {task.is_locked && (
//     <span className="text-[10px] px-2 py-1 rounded-full bg-orange-500/20 text-orange-400">
//       🔒 Locked
//     </span>
//   )}
// </div>

     
//     </div>

    
//   </div>
// );


//   // if (!draggable) return CardContent;
//   if (!draggable || task.is_locked) return CardContent;


//   return (
//     <Draggable draggableId={String(task.id)} index={index}>
//       {(provided) => (
//         <div
//           ref={provided.innerRef}
//           {...provided.draggableProps}
//           {...provided.dragHandleProps}
//           style={provided.draggableProps.style}
//         >
//           {CardContent}
//         </div>
//       )}
//     </Draggable>
//   );
// }



